import React, { CSSProperties } from 'react';
import cnLogo from 'src/assets/images/logo/logo_animalcrossing_cn.svg';
import enLogo2x from 'src/assets/images/logo/logo_animalcrossing_en-2x.png';
import enLogo from 'src/assets/images/logo/logo_animalcrossing_en.png';
import jaLogo from 'src/assets/images/logo/logo_animalcrossing_ja.svg';
import koLogo from 'src/assets/images/logo/logo_animalcrossing_ko.svg';
import twLogo from 'src/assets/images/logo/logo_animalcrossing_tw.svg';

interface ParkLogoProps {
  lang: string;
  width?: number;
  height?: number;
}

export const ParkLogo: React.FC<ParkLogoProps> = ({ lang, width, height }) => {
  const style: CSSProperties = {
    width: width ? `${width}px` : 'auto',
    height: height ? `${height}px` : 'auto',
    objectFit: 'contain'
  };

  switch (lang) {
    case 'ja':
    case 'ja-JP':
      return <img style={style} width={256} height={120} src={jaLogo} alt="" aria-hidden={true} />;

    case 'zh':
    case 'zh-CN':
      return <img style={style} width={256} height={120} src={cnLogo} alt="" aria-hidden={true} />;

    case 'zh-TW':
      return <img style={style} width={256} height={120} src={twLogo} alt="" aria-hidden={true} />;

    case 'ko':
    case 'ko-KR':
      return <img style={style} width={256} height={120} src={koLogo} alt="" aria-hidden={true} />;

    default:
      return (
        <img
          style={style}
          width={256}
          height={120}
          srcSet={`${enLogo} 1x, ${enLogo2x} 2x`}
          alt=""
          aria-hidden={true}
        />
      );
  }
};
